module.exports = __webpack_public_path__ + "static/media/timecut-logo.7eff7c4d.png";